import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import type { Dispatch, SetStateAction } from 'react'

import type { ColumnCategory } from './useColumns'

interface ColumnPickerCategoryListProps {
  columnCategories: ColumnCategory[]
  setCurrentCategory: Dispatch<SetStateAction<string | null>>
}
export const ColumnPickerCategoryList = ({
  columnCategories,
  setCurrentCategory,
}: ColumnPickerCategoryListProps) => (
  <List sx={{ p: 2 }} data-test-id="dynamic-category-container">
    {columnCategories
      .filter((category) => !category.hidden)
      .map((category) => (
        <ListItemButton
          key={category.prefix}
          sx={{ borderRadius: 1.5, py: 0.75 }}
          onClick={() => setCurrentCategory(category.name)}
          data-test-id={`dynamic-category-${category.prefix}`}
        >
          <ListItemText
            primary={category.name}
            slotProps={{
              primary: {
                variant: 'body2',
              },
            }}
          />
        </ListItemButton>
      ))}
  </List>
)
